import { client } from '@/client';
import { resolveData } from '@/util/api-helpers';

export async function fetchMetadata({ state, commit }) {
   if (state.metadata) {
      return Promise.resolve();
   }
   return client.get('/api/metadata')
      .then(resolveData)
      .then(metadata => {
         commit('setMetadata', metadata);
         commit('setLoaded', true);
      });
}
